<style src="./DashboardParking.scss"  lang="scss"></style>
<template>
  <div>
    <header class="header-container">
      <button class="btn btn-outline" @click="loadParksInfo">
        <i class="fa fa-refresh"></i>
      </button>
    </header>
    <draggable class="dashbard-parking">
      <park-block
        class="park"
        v-for="(park, parkIdx) in parks"
        :key="parkIdx"
        :park="park"
      />
    </draggable>
  </div>
</template>

<script>
import ParkBlock from './components/park-block/ParkBlock.vue';
import draggable from 'vuedraggable';

export default {
  name: 'DashboardParking',
  components: {
    ParkBlock,
    draggable,
  },
  data: () => ({
    parks: [],
  }),
  mounted() {
    // this.parks = fakeParksInfo();
    this.loadParksInfo();
  },
  methods: {
    async loadParksInfo() {
      try {
        const parksInfo = await this.$store.dispatch(
          'PARKING-DASHBOARD/GetParkingDashboardInfo',
        );
        this.parks = parksInfo;
      } catch (error) {
        this.$toasted.error('Falha ao carregar informações');
      }
    },
  },
};
</script>
